<template>
    <div class="main">
        <c-panel title="APLICAÇÃO EM LOTE — TIPO DE AVALIAÇÃO E FÓRMULA" titleIcon="fas fa-layer-group">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="O lote atinge apenas turmas do curso da etapa escolhida, no período letivo informado, com a mesma quantidade de períodos avaliativos e SEM notas lançadas. Turmas com nota nunca são alteradas."></el-alert>

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Matriz curricular">
                            <el-select v-model="matrizId" style="width: 100%;" filterable @change="carregarEtapas">
                                <el-option v-for="m in matrizes" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Etapa">
                            <el-select v-model="etapaId" style="width: 100%;" filterable :disabled="!matrizId" @change="limpar">
                                <el-option v-for="e in etapas" :key="e.id" :value="e.id" :label="e.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período letivo">
                            <el-select v-model="periodoLetivoId" style="width: 100%;" @change="limpar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Tipo de avaliação a aplicar">
                            <el-select v-model="tipoAvaliacaoId" style="width: 100%;" filterable clearable @change="limpar">
                                <el-option v-for="t in tipos" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Fórmula de cálculo a aplicar">
                            <el-select v-model="formulaCalculoId" style="width: 100%;" filterable clearable @change="limpar">
                                <el-option v-for="f in formulas" :key="f.id" :value="f.id" :label="f.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" style="padding-top: 30px;">
                        <el-button type="warning" @click="classificar" :disabled="!etapaId || (!tipoAvaliacaoId && !formulaCalculoId)" plain>
                            1. VER PRÉVIA
                        </el-button>
                        <el-button class="u-ml-10" type="primary" @click="aplicar" :disabled="!resultado || !resultado.elegiveis.length">
                            2. APLICAR
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>

            <template v-if="resultado">
                <el-alert type="info" :closable="false" class="u-mb-15"
                    :title="`Prévia: ${resultado.elegiveis.length} turma(s) elegível(is), ${resultado.sem_alteracao.length} sem alteração necessária, ${resultado.ignoradas.length} ignorada(s). A elegibilidade é recalculada no momento de aplicar.`"></el-alert>

                <h4 v-if="resultado.elegiveis.length">Elegíveis ({{ resultado.elegiveis.length }})</h4>
                <div class="container-table u-mb-20" v-if="resultado.elegiveis.length">
                    <table class="table table-striped">
                        <thead>
                            <tr><th style="width: 90px;">Turma</th><th>Nome</th><th style="width: 300px;">Será aplicado</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="t in resultado.elegiveis" :key="t.turma_id">
                                <td>{{ t.turma_id }}</td>
                                <td>{{ t.nome }}</td>
                                <td>
                                    <span v-if="t.configuracao.tipo_avaliacao_id">tipo de avaliação</span>
                                    <span v-if="t.configuracao.tipo_avaliacao_id && t.configuracao.formula_calculo_id"> e </span>
                                    <span v-if="t.configuracao.formula_calculo_id">fórmula de cálculo</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4 v-if="resultado.sem_alteracao.length">Sem alteração necessária ({{ resultado.sem_alteracao.length }})</h4>
                <div class="container-table u-mb-20" v-if="resultado.sem_alteracao.length">
                    <table class="table table-striped">
                        <thead><tr><th style="width: 90px;">Turma</th><th>Nome</th><th style="width: 300px;">Motivo</th></tr></thead>
                        <tbody>
                            <tr v-for="t in resultado.sem_alteracao" :key="t.turma_id">
                                <td>{{ t.turma_id }}</td><td>{{ t.nome }}</td><td>{{ t.motivo }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4 v-if="resultado.ignoradas.length">Ignoradas ({{ resultado.ignoradas.length }})</h4>
                <div class="container-table" v-if="resultado.ignoradas.length">
                    <table class="table table-striped">
                        <thead><tr><th style="width: 90px;">Turma</th><th>Nome</th><th style="width: 380px;">Motivo</th></tr></thead>
                        <tbody>
                            <tr v-for="t in resultado.ignoradas" :key="t.turma_id">
                                <td>{{ t.turma_id }}</td><td>{{ t.nome }}</td>
                                <td style="color: #E6A23C;">{{ t.motivo }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </c-panel>
    </div>
</template>

<script>
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        matrizes: [], etapas: [], tipos: [], formulas: [],
        matrizId: '', etapaId: '', periodoLetivoId: '', tipoAvaliacaoId: '', formulaCalculoId: '',
        resultado: null
    }),
    mounted () {
        this.periodoLetivoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''
        const h = this.$store.getters.getHeaderAuth
        const base = this.$store.state.config.baseUrlApi
        this.$axios.get(`${base}/api/matriz-curricular/getAll`, h).then(r => { this.matrizes = r.data || [] }).catch(() => {})
        this.$axios.get(`${base}/api/tipo-avaliacao/getAll`, h).then(r => { this.tipos = r.data || [] }).catch(() => {})
        this.$axios.get(`${base}/api/formula-calculo/getAll`, h).then(r => { this.formulas = r.data || [] }).catch(() => {})
    },
    methods: {
        limpar () { this.resultado = null },
        carregarEtapas () {
            this.etapaId = ''
            this.etapas = []
            this.limpar()
            if (!this.matrizId) return
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapas/${this.matrizId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.etapas = r.data || [] }).catch(() => {})
        },
        payload () {
            const p = { matriz_etapa_id: this.etapaId, periodo_letivo_id: this.periodoLetivoId }
            if (this.tipoAvaliacaoId) p.tipo_avaliacao_id = this.tipoAvaliacaoId
            if (this.formulaCalculoId) p.formula_calculo_id = this.formulaCalculoId
            return p
        },
        classificar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/lote-avaliacao/classificar`,
                this.payload(),
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    this.resultado = null
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.resultado = r.data
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        aplicar () {
            this.$msgbox.confirm(
                `Aplicar a configuração em ${this.resultado.elegiveis.length} turma(s)? A elegibilidade será recalculada e turmas com nota lançada continuarão fora.`,
                'Atenção', { confirmButtonText: 'Aplicar', cancelButtonText: 'Cancelar', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                // Reenvia os mesmos parâmetros: a API reclassifica e revalida do zero.
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/lote-avaliacao/aplicar`,
                    this.payload(),
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        this.classificar()
                        return
                    }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                    this.classificar()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        }
    }
}
</script>
